import type { WorldCoords } from './world';

export type CaptureZone = {
  coords: WorldCoords;
  radius: number;
};
